import { render, staticRenderFns } from "./modal-notes.vue?vue&type=template&id=0e8dcd08"
import script from "./modal-notes.vue?vue&type=script&lang=js"
export * from "./modal-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports